import React, { Component } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import emailjs from "emailjs-com";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";

const SERVICE_ID = "service_3qq5tmg";
const TEMPLATE_ID = "template_g3mrj1g";
const PUBLIC_KEY = "4EA9FyotVNbcsvPoR";

class RequestDemo extends Component {
  state = {
    name: "",
    company: "",
    phone: "",
    email: "",
    location: "",
    product: "TeaSof ERP",
    message: "",
    emailStatus: "",
    sending: false,
  };

  handleChange = (input) => (e) => {
    this.setState({ [input]: e.target.value });
  };

  submitForm = (e) => {
    e.preventDefault();
    const { name, company, phone, email, location, product, message } = this.state;

    const templateParams = {
      from_name: name,
      from_email: email,
      mobile: phone,
      address: location,
      company: company,
      product: product,
      message: message,
      subject: `Demo Request - ${product} (${company})`,
    };

    this.setState({ sending: true });

    emailjs
      .send(SERVICE_ID, TEMPLATE_ID, templateParams, PUBLIC_KEY)
      .then(() => {
        Swal.fire({
          icon: "success",
          title: "Demo Request Sent!",
          text: "Thanks! Our team will contact you shortly.",
        });

        this.setState({
          name: "",
          company: "",
          phone: "",
          email: "",
          location: "",
          product: "TeaSof ERP",
          message: "",
          emailStatus: "success",
          sending: false,
        });
      })
      .catch(() => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Email sending failed. Please try again or call sales.",
        });
        this.setState({ emailStatus: "error", sending: false });
      });
  };

  render() {
    const { name, company, phone, email, location, product, message, emailStatus, sending } = this.state;

    return (
      <div style={{ background: "#f6f8fb", minHeight: "100vh", padding: "34px 0" }}>
        <Container>
          {/* TOP HEADER */}
          <Row className="align-items-center mb-3">
            <Col>
              <h2 style={{ margin: 0, fontWeight: 900, color: "#0f172a" }}>Request a Demo</h2>
              <p style={{ marginTop: 8, color: "#64748b", lineHeight: 1.7 }}>
                Submit your details and our team will contact you to schedule a product walkthrough.
              </p>
            </Col>
            <Col className="text-lg-end mt-3 mt-lg-0">
              <Link className="btn btn-outline-primary" to="/teasof">
                ← Back to TeaSof
              </Link>
            </Col>
          </Row>

          <Row className="g-4">
            {/* FORM */}
            <Col lg={7}>
              <Card style={{ borderRadius: 18, border: "1px solid #e5e7eb", boxShadow: "0 12px 24px rgba(2,6,23,0.06)" }}>
                <Card.Body style={{ padding: 20 }}>
                  {emailStatus === "success" && (
                    <div className="alert alert-success mb-3" style={{ borderRadius: 14 }}>
                      ✅ Demo request sent successfully!
                    </div>
                  )}
                  {emailStatus === "error" && (
                    <div className="alert alert-danger mb-3" style={{ borderRadius: 14 }}>
                      ❌ Failed to send demo request. Please try again.
                    </div>
                  )}

                  <form onSubmit={this.submitForm}>
                    <Row className="g-3">
                      <Col md={6}>
                        <input
                          className="form-control"
                          type="text"
                          value={name}
                          onChange={this.handleChange("name")}
                          placeholder="Full Name *"
                          required
                        />
                      </Col>

                      <Col md={6}>
                        <input
                          className="form-control"
                          type="text"
                          value={company}
                          onChange={this.handleChange("company")}
                          placeholder="Company / Estate *"
                          required
                        />
                      </Col>

                      <Col md={6}>
                        <input
                          className="form-control"
                          type="tel"
                          value={phone}
                          onChange={this.handleChange("phone")}
                          placeholder="Phone *"
                          required
                        />
                      </Col>

                      <Col md={6}>
                        <input
                          className="form-control"
                          type="email"
                          value={email}
                          onChange={this.handleChange("email")}
                          placeholder="Email"
                        />
                      </Col>

                      <Col md={12}>
                        <input
                          className="form-control"
                          type="text"
                          value={location}
                          onChange={this.handleChange("location")}
                          placeholder="Location (District / State)"
                        />
                      </Col>

                      <Col md={12}>
                        <select className="form-control" value={product} onChange={this.handleChange("product")}>
                          <option value="TeaSof ERP">TeaSof ERP</option>
                          <option value="HotelSof">HotelSof</option>
                          <option value="WardMaster">WardMaster</option>
                          <option value="JewSof">JewSof</option>
                          <option value="Restaurant Software">Restaurant Software</option>
                          <option value="Retail POS">Retail POS</option>
                          <option value="Other / Custom Software">Other / Custom Software</option>
                        </select>
                      </Col>

                      <Col md={12}>
                        <textarea
                          className="form-control"
                          rows="4"
                          value={message}
                          onChange={this.handleChange("message")}
                          placeholder="Tell us your requirements (wages, inventory, billing, accounts, etc.)"
                          required
                        />
                      </Col>

                      <Col md={12} className="d-flex gap-2 flex-wrap">
                        <button type="submit" className="btn btn-primary btn-lg" disabled={sending}>
                          {sending ? "Sending..." : "Submit Demo Request"}
                        </button>

                        <a className="btn btn-outline-secondary btn-lg" href="tel:+919733721111">
                          Call Sales: +91 97337 2 1111
                        </a>
                      </Col>
                    </Row>
                  </form>
                </Card.Body>
              </Card>
            </Col>

            {/* CONTACT BOX */}
            <Col lg={5}>
              <Card style={{ borderRadius: 18, border: "1px solid #e5e7eb", boxShadow: "0 12px 24px rgba(2,6,23,0.06)" }}>
                <Card.Body style={{ padding: 20 }}>
                  <h5 style={{ fontWeight: 900, color: "#0f172a", marginBottom: 8 }}>Sales & Support</h5>
                  <p style={{ color: "#64748b", lineHeight: 1.7 }}>
                    After submission, our team will confirm your requirements and schedule a demo.
                  </p>

                  <div style={{ fontWeight: 900, fontSize: 18 }}>
                    <a href="tel:+919733721111" style={{ textDecoration: "none" }}>
                      +91 97337 2 1111
                    </a>
                  </div>

                  <hr />

                  <div style={{ color: "#64748b", lineHeight: 1.7 }}>
                    <div>
                      <b>Email:</b> info@ebssoftware.co.in
                    </div>
                    <div className="mt-2">
                      <b>Office:</b> +91 353 405 5548
                    </div>
                    <div className="mt-2">
                      <b>Address:</b> EBS IT Park,Near Uttar Banga Sambad Press,Madhya Shanti Nagar, Siliguri, Jalpaiguri, West Bengal, India
                      (734004)
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default RequestDemo;
